import React from 'react';
import { useTranslation } from "react-i18next";
import HeroSection from '../../components/sections/HeroSection';
import FooterSection from '../../components/sections/FooterSection';
import DividersInfoSection from '../../components/sections/DividersInfoSection';
import FaqAccordionsSection from '../../components/sections/FaqAccordionsSection';
import FactsAndStatsSection from '../../components/sections/FactsAndStatsSection';
import BigTinyIntroSection from '../../components/sections/BigTinyIntroSection';
import ParallaxCallSection from '../../components/sections/ParallaxCallSection';

function KaragandaCityPage(props) {

    var { t } = useTranslation();

    var faqItems = [
        { question: "What documents are required?", answer: "Passport valid for at least 6 months, visa application form, passport photos, proof of accommodation, and travel insurance are standard requirements." },
        { question: "How long does processing take?", answer: "Standard processing usually takes up to 5 working days, while express processing can be completed in 48 hours depending on consular workload." },
        { question: "Can business delegations apply?", answer: "Yes, corporate visa packages are available for delegations, including bulk submissions, account-based invoicing, and consolidated document delivery." },
        { question: "Is visa on arrival available?", answer: "Visa on arrival is limited to specific cases. Pre-application ensures guaranteed entry and avoids administrative delays at the border." }
    ];

    return (
        <>
            <HeroSection
                isExpectingAnimations={true}
                i18nTitleKey="infopages.cities.karaganda.title"
                i18nParagraphKey="infopages.cities.karaganda.paragraph1"
                i18nCallToActionKey="infopages.cities.karaganda.cta"
                backgroundImageUrl="https://i.ytimg.com/vi/PJTOM1MoIjs/maxresdefault.jpg"
            />
            
            <div className='uk-container uk-section'>
                <BigTinyIntroSection
                    Big="Karaganda originated in the early twentieth century as a mining settlement formed around large coal deposits in central Kazakhstan. Official city status followed in 1934, after which the urban area grew into a major industrial center of the republic. Continuous development of metallurgy, energy production, logistics, and construction established Karaganda as one of the most employment-intensive regions in the country, with a high and stable demand for additional labor resources."
                    Tiny="Current urban expansion includes new residential districts, modernization of industrial facilities, and growth of transportation and service infrastructure. These sectors generate consistent recruitment needs for low-skilled and semi-skilled workers. A diversified economy, centralized location, and sustained investment activity position Karaganda as a rapidly advancing labor market well-suited for foreign workers entering officially regulated employment programs."
                />
            </div>

            <ParallaxCallSection
                URL="https://i.ytimg.com/vi/xP5eHhoZRFk/maxresdefault.jpg"
                headline="Experience the Future in Karaganda"
                callToAction="Secure your Kazakhstan visa with Jai!"
            />

            {/* Quick Facts / Statistics */}
            <FactsAndStatsSection
                sectionTitle="Quick Facts"
                stat1="90%"
                fact1="Visa approval rate"
                stat2="635+"
                fact2="Clients served"
                stat3="14"
                fact3="Days processing time"
                stat4="1934"
                fact4="Year city founded"
            />

            {/* FAQ Accordion */}
            <FaqAccordionsSection
                items={faqItems}
            />

            <div className='uk-container'>
                {/* Infosection with shitloads of dividers */}
                <DividersInfoSection />
            </div>

            <FooterSection />
        </>
    );
}

export default KaragandaCityPage;